export const LABEL_COLORS: { value: string; name: string }[] = [
  { value: '#ef4444', name: 'Red' },
  { value: '#f97316', name: 'Orange' },
  { value: '#f59e0b', name: 'Amber' },
  { value: '#eab308', name: 'Yellow' },
  { value: '#84cc16', name: 'Lime' },
  { value: '#22c55e', name: 'Green' },
  { value: '#10b981', name: 'Emerald' },
  { value: '#14b8a6', name: 'Teal' },
  { value: '#06b6d4', name: 'Cyan' },
  { value: '#0ea5e9', name: 'Sky' },
  { value: '#3b82f6', name: 'Blue' },
  { value: '#6366f1', name: 'Indigo' },
  { value: '#8b5cf6', name: 'Violet' },
  { value: '#a855f7', name: 'Purple' },
  { value: '#d946ef', name: 'Fuchsia' },
  { value: '#ec4899', name: 'Pink' },
  { value: '#f43f5e', name: 'Rose' },
  { value: '#b91c1c', name: 'Dark Red' },
  { value: '#c2410c', name: 'Dark Orange' },
  { value: '#b45309', name: 'Dark Amber' },
  { value: '#15803d', name: 'Dark Green' },
  { value: '#0f766e', name: 'Dark Teal' },
  { value: '#0369a1', name: 'Dark Blue' },
  { value: '#4338ca', name: 'Dark Indigo' },
  { value: '#7c3aed', name: 'Dark Violet' },
  { value: '#9d174d', name: 'Dark Pink' },
  { value: '#6b7280', name: 'Gray' },
  { value: '#374151', name: 'Dark Gray' },
  { value: '#1e293b', name: 'Slate' },
  { value: '#78716c', name: 'Stone' },
];

export const COLUMN_ACCENT_COLORS = [
  '#6366f1',
  '#f59e0b',
  '#10b981',
  '#ef4444',
  '#3b82f6',
  '#8b5cf6',
  '#ec4899',
  '#14b8a6',
];

export const AVATAR_PALETTE = [
  { bg: '#dbeafe', color: '#1d4ed8' },
  { bg: '#dcfce7', color: '#166534' },
  { bg: '#fef3c7', color: '#92400e' },
  { bg: '#fce7f3', color: '#be185d' },
  { bg: '#f3e8ff', color: '#7e22ce' },
  { bg: '#ffedd5', color: '#c2410c' },
];
